import request from 'utils/request';
import { PUSH_URL } from 'utils/api';

export const getPushOperation = async (operationId, quantity) => {
  return await request(`${PUSH_URL}?OperacaoId=${operationId}&Quantidade=${quantity}`, {}, 120000, 'application/json')
    .then(response => {
      const { error } = response;
      const hasError = Boolean(error);

      return {
        error: hasError,
        data: response,
      }
    })
};
